var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssignment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 2.59961H13.875C14.306 2.59961 14.7193 2.76818 15.024 3.06824C15.3288 3.3683 15.5 3.77526 15.5 4.19961V15.3996C15.5 15.824 15.3288 16.2309 15.024 16.531C14.7193 16.831 14.306 16.9996 13.875 16.9996H4.125C3.69402 16.9996 3.2807 16.831 2.97595 16.531C2.6712 16.2309 2.5 15.824 2.5 15.3996V4.19961C2.5 3.77526 2.6712 3.3683 2.97595 3.06824C3.2807 2.76818 3.69402 2.59961 4.125 2.59961H5.75",
    stroke: "#5C6370",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4375 1H6.5625C6.11377 1 5.75 1.35817 5.75 1.8V3.4C5.75 3.84183 6.11377 4.2 6.5625 4.2H11.4375C11.8862 4.2 12.25 3.84183 12.25 3.4V1.8C12.25 1.35817 11.8862 1 11.4375 1Z",
    stroke: "#5C6370",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65088 10.8096L12.1509 10.8096",
    stroke: "#5C6370",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65088 7.60937L12.1509 7.60938",
    stroke: "#5C6370",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5259 14.0098L11.3384 14.0098L12.1509 14.0098",
    stroke: "#5C6370",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignment);
export default __webpack_public_path__ + "static/media/assignment.8a294f2a38d9c82942f5b0627e48537d.svg";
export { ForwardRef as ReactComponent };